function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import getFileType from '@uppy/utils/lib/getFileType';
import isPreviewSupported from '@uppy/utils/lib/isPreviewSupported';
import generateFileID from '@uppy/utils/lib/generateFileID'; // TODO: now that we have a shared `View` class,
// `SharedHandler` could be cleaned up and moved into here

import SharedHandler from './SharedHandler.js';

var View = /*#__PURE__*/function () {
  function View(plugin, opts) {
    _classCallCheck(this, View);

    this.plugin = plugin;
    this.provider = opts.provider;
    this.sharedHandler = new SharedHandler(plugin);
    this.isHandlingScroll = false;
    this.preFirstRender = this.preFirstRender.bind(this);
    this.handleError = this.handleError.bind(this);
    this.addFile = this.addFile.bind(this);
    this.clearSelection = this.clearSelection.bind(this);
    this.cancelPicking = this.cancelPicking.bind(this);
  } // eslint-disable-next-line class-methods-use-this


  _createClass(View, [{
    key: "providerFileToId",
    value: function providerFileToId(file) {
      return generateFileID({
        data: file,
        name: file.name || file.id,
        type: file.mimetype
      });
    }
  }, {
    key: "preFirstRender",
    value: function preFirstRender() {
      this.plugin.setPluginState({
        didFirstRender: true
      });
      this.plugin.onFirstRender();
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: "shouldHandleScroll",
    value: function shouldHandleScroll(event) {
      var _event$target = event.target,
          scrollHeight = _event$target.scrollHeight,
          scrollTop = _event$target.scrollTop,
          offsetHeight = _event$target.offsetHeight;
      var scrollPosition = scrollHeight - (scrollTop + offsetHeight);
      return scrollPosition < 50 && !this.isHandlingScroll;
    }
  }, {
    key: "clearSelection",
    value: function clearSelection() {
      this.plugin.setPluginState({
        currentSelection: [],
        filterInput: ''
      });
    }
  }, {
    key: "cancelPicking",
    value: function cancelPicking() {
      this.clearSelection();
      var dashboard = this.plugin.uppy.getPlugin('Dashboard');

      if (dashboard) {
        dashboard.hideAllPanels();
      }
    }
  }, {
    key: "handleError",
    value: function handleError(error) {
      var uppy = this.plugin.uppy;
      var message = uppy.i18n('companionError');
      uppy.log(error.toString());

      if (error.isAuthError) {
        return;
      }

      uppy.info({
        message: message,
        details: error.toString()
      }, 'error', 5000);
    }
  }, {
    key: "addFile",
    value: function addFile(file) {
      var tagFile = {
        id: this.providerFileToId(file),
        source: this.plugin.id,
        data: file,
        name: file.name || file.id,
        type: file.mimeType,
        isRemote: true,
        meta: {},
        body: {
          fileId: file.id
        },
        remote: {
          companionUrl: this.plugin.opts.companionUrl,
          url: "".concat(this.provider.fileUrl(file.requestPath)),
          body: {
            fileId: file.id
          },
          providerOptions: this.provider.opts,
          providerName: this.provider.name
        }
      };
      var fileType = getFileType(tagFile); // TODO Should we just always use the thumbnail URL if it exists?

      if (fileType && isPreviewSupported(fileType)) {
        tagFile.preview = file.thumbnail;
      }

      if (file.author) {
        if (file.author.name != null) tagFile.meta.authorName = String(file.author.name);
        if (file.author.url) tagFile.meta.authorUrl = file.author.url;
      }

      this.plugin.uppy.log('Adding remote file');

      try {
        this.plugin.uppy.addFile(tagFile);
        return true;
      } catch (err) {
        if (!err.isRestriction) {
          this.plugin.uppy.log(err);
        }

        return false;
      }
    }
  }]);

  return View;
}();

export { View as default };